import { useLayoutEffect, useRef, useState, type CSSProperties } from 'react';
import type { MarkaYolu } from './markaYollari';
import { useGorunceOyna } from './useMarkaAnimasyonu';

// Prerender edilmis HTML'de ust logo zaten 'oyna' sinifiyla gelir ve animasyon ilk boyamada baslar.
// React (createRoot) DOM'u yeniden kurunca animasyon bastan baslamasin diye kaldigi yer hesaplanir.
const statikAcilisVardi =
  typeof document !== 'undefined' && !!document.querySelector('.logo-ciz.oyna');
let acilisOynadi = false;

interface LogoCizimProps {
  src: string;
  alt: string;
  /** Logonun silueti (gorselle ayni piksel uzayinda). */
  yol: MarkaYolu;
  /** Cizgi rengi: logonun dis hattinin rengi. */
  renk: string;
  className?: string;
  /** acilis: sayfa acilisinda bir kez (ust menu) | gorunce: ekrana girince (footer). */
  mod?: 'acilis' | 'gorunce';
  cizgi?: number;
}

/** Logo once dis hattiyla kendini cizer, sonra gercek logo belirir ve sabit kalir. */
export default function LogoCizim({ src, alt, yol, renk, className = '', mod = 'acilis', cizgi = 18 }: LogoCizimProps) {
  const ref = useRef<HTMLSpanElement>(null);
  const [acilisDurumu] = useState(() => (mod === 'acilis' && !acilisOynadi ? 'oyna' : 'sabit'));
  const gorunceDurumu = useGorunceOyna(ref, 0.6);
  const durum = mod === 'acilis' ? acilisDurumu : gorunceDurumu;

  useLayoutEffect(() => {
    if (mod !== 'acilis' || acilisDurumu !== 'oyna') return;
    acilisOynadi = true;
    if (statikAcilisVardi && !navigator.webdriver && ref.current) {
      const boya = performance.getEntriesByType('paint').find((p) => p.name === 'first-contentful-paint');
      const gecen = Math.max(0, Math.round(performance.now() - (boya?.startTime ?? performance.now())));
      ref.current.style.setProperty('--gecen', `-${gecen}ms`);
    }
  }, [mod, acilisDurumu]);

  return (
    <span ref={ref} className={`logo-ciz ${durum} ${className}`}>
      <img src={src} alt={alt} className="block h-full w-auto" />
      <svg viewBox={yol.vb} aria-hidden="true" focusable="false">
        {yol.yollar.map((d, i) => (
          <path
            key={i}
            d={d}
            pathLength={1}
            className="lc-hat"
            stroke={renk}
            strokeWidth={cizgi}
            strokeLinejoin="round"
            strokeLinecap="round"
            style={{ '--i': i } as CSSProperties}
          />
        ))}
      </svg>
    </span>
  );
}
